<template>
    <div class="thanks">拒绝访问!</div>
</template>

<script>
    export default {
        name: "Thanks"
    }
</script>

<style scoped>
.thanks{

    text-align: center;
    font-size: 30px;
    color: darkgray;
}
</style>
